import { designTokens } from './tokens';

export type ProgressTone = 'neutral' | 'active' | 'success' | 'danger';

const tones = {
  neutral: { background: designTokens.color.subtleSurface, color: designTokens.color.secondaryText, border: designTokens.color.divider },
  active: { background: designTokens.color.selectedNavigationSurface, color: designTokens.color.actionDark, border: designTokens.color.brandBorder },
  success: { background: designTokens.color.successSoft, color: designTokens.color.successText, border: designTokens.color.successSoft },
  danger: { background: designTokens.color.dangerSoft, color: designTokens.color.dangerText, border: designTokens.color.dangerSoft },
} as const;

export function progressMarkerStyles(tone: ProgressTone) {
  const presentation = tones[tone];
  return {
    width: designTokens.progress.markerSize,
    height: designTokens.progress.markerSize,
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    boxSizing: 'border-box',
    borderRadius: designTokens.radius.circle,
    backgroundColor: presentation.background,
    color: presentation.color,
    border: `1px solid ${presentation.border}`,
    ...designTokens.typography.supporting,
    fontWeight: 500,
    '@media (forced-colors: active)': { borderColor: tone === 'active' ? 'Highlight' : 'CanvasText', color: 'CanvasText' },
  } as const;
}
